import { render, staticRenderFns } from "./AnswerOptions.vue?vue&type=template&id=654391d1&scoped=true"
import script from "./AnswerOptions.vue?vue&type=script&lang=js"
export * from "./AnswerOptions.vue?vue&type=script&lang=js"
import style0 from "./AnswerOptions.vue?vue&type=style&index=0&id=654391d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654391d1",
  null
  
)

export default component.exports